import { AppFirestoreService } from 'src/app/_services/app-firestore.service';
import { AuthService } from './../../_services/auth.service';
import { Component, OnInit, AfterViewInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
declare var JitsiMeetExternalAPI: any;

@Component({
  selector: 'app-jitsi',
  templateUrl: './jitsi.component.html',
  styleUrls: ['./jitsi.component.scss']
})
export class JitsiComponent implements OnInit, AfterViewInit {

  @HostListener('window:resize', ['$event'])

  domain: string = "meet.jit.si"; // For self hosted use your domain
  room: any;
  options: any;
  api: any;
  user: any;
  screenHeight: number;
  screenWidth: number;
  joinedParticipants = [];
  // For Custom Controls

  constructor(
    private router: Router,
    private routing: ActivatedRoute,
    public auth: AuthService,
    private afs: AppFirestoreService
  ) { }

  ngOnInit(): void {
    this.routing.params.subscribe(
      data => {
        this.room = data.id
        this.joinedParticipants = [];
      }
    ); // Set your room name
  }

  ngAfterViewInit(): void {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    this.options = {
      roomName: this.room,
      // width: this.screenWidth,
      // height: this.screenHeight,
      width: this.screenWidth - 25,
      height: this.screenHeight- 25,
      configOverwrite: { prejoinPageEnabled: false },
      interfaceConfigOverwrite: {
        BRAND_WATERMARK_LINK: 'https://static.wixstatic.com/media/7967c0_d515b421c45045d99d9673bcaa7cbdf5~mv2.jpg/v1/fill/w_1070,h_230,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/logo-white.jpg',
        SHOW_BRAND_WATERMARK: true,
      },
      parentNode: document.querySelector('#jitsi-iframe'),
      userInfo: {
        displayName: 'Demo User'
      }
    }

    this.api = new JitsiMeetExternalAPI(this.domain, this.options);

    // Event handlers
    this.api.addEventListeners({
      readyToClose: this.handleClose,
      participantLeft: this.handleParticipantLeft,
      participantJoined: this.handleParticipantJoined,
      videoConferenceJoined: this.handleVideoConferenceJoined,
      videoConferenceLeft: this.handleVideoConferenceLeft,
      audioMuteStatusChanged: this.handleMuteStatus,
      videoMuteStatusChanged: this.handleVideoStatus,
      getLivestream: this.getLivestream
    });
  }

  handleClose = () => {
  }


  getLivestream = async (participant) => {
    const data = await this.getLivestreamUrl();
  }

  handleParticipantLeft = async (participant) => {
    const data = await this.getParticipants();
  }

  handleParticipantJoined = async (participant) => {
    this.joinedParticipants.push(participant)
     // { id: "2baa184e", displayName: "Shanu Verma", formattedDisplayName: "Shanu Verma" }
    const data = await this.getParticipants();
    this.afs.collection('room').doc(this.room).set({users: this.joinedParticipants}, {merge: true}).then(x => {
      console.log(x);
    });


  }

  handleVideoConferenceJoined = async (participant) => {
    // console.log("handleVideoConferenceJoined", participant); // { roomName: "bwb-bfqi-vmh", id: "8c35a951", displayName: "Akash Verma", formattedDisplayName: "Akash Verma (me)"}
    const data = await this.getParticipants();
  }

  handleVideoConferenceLeft = () => {
    // console.log("handleVideoConferenceLeft");
    this.router.navigate(['/thank-you']);
  }

  handleMuteStatus = (audio) => {
    // console.log("handleMuteStatus", audio); // { muted: true }
  }

  handleVideoStatus = (video) => {
    // console.log("handleVideoStatus", video); // { muted: true }
  }

  getParticipants() {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(this.api.getParticipantsInfo()); // get all participants
      }, 500)
    });
  }

  getLivestreamUrl() {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(this.api.getLivestreamUrl());
      }, 500)
    });
  }

  executeCommand(command: string) {
    this.api.executeCommand(command);;
    if (command == 'hangup') {
      this.router.navigate(['/thank-you']);
      return;
    }
  }
}
